const AttendanceStats = ({ sessionStats }) => (
  <div className="session-stats">
    <div className="stat-card">
      <div className="stat-value">{sessionStats.total}</div>
      <div className="stat-label">Total Scans</div>
    </div>
    <div className="stat-card success">
      <div className="stat-value">{sessionStats.successful}</div>
      <div className="stat-label">Successful</div>
    </div>
    <div className="stat-card error">
      <div className="stat-value">{sessionStats.failed}</div>
      <div className="stat-label">Failed</div>
    </div>
  </div>
);

export default AttendanceStats;
